export default __webpack_public_path__ + "static/media/new_avatar.d36a117a.jpeg";